var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{staticClass:"global-progress-bar",attrs:{"active":_vm.loading,"height":"4","indeterminate":true}})}
var staticRenderFns = []

export { render, staticRenderFns }